// 1. Define the possible base URLs for your APIs.
//    Replace these with your actual production and development URLs.
const API_URLS = {
    development: 'https://jv7kamkda6.alpicapture.com',
    production: 'https://rpc.alpicapture.com',
};

/**
 * Determines the runtime environment and API configuration based on a URL parameter.
 * @returns {{API_BASE_URL: string, ENV: 'production' | 'development'}}
 */
function getApiConfig() {
    const urlParams = new URLSearchParams(window.location.search);
    const env = urlParams.get('env'); // e.g., 'dev' or 'development'

    // If the 'env' parameter specifies development, use the development URL.
    if (env === 'dev' || env === 'development') {
        return {
            API_BASE_URL: API_URLS.development,
            ENV: 'development'
        };
    }

    // For any other case (including no 'env' parameter), default to production for safety.
    return {
        API_BASE_URL: API_URLS.production,
        ENV: 'production'
    };
}

// 2. Execute the function and export the resulting configuration object.
const config = getApiConfig();

export default config;